
export function imagesLoaded(parentNode) {
  const imgElements = parentNode.querySelectorAll('img');
  for (let img = 0, l = imgElements.length; img < l; img++) {
    if (!imgElements[img].complete) {
      return 'loading';
    }
  }
  return 'loaded';
}



/** WEBPACK FOOTER **
 ** ./src/helpers/imagesLoadCheck.js
 **/